class EnvironmentService {
  getApiUrlSync() {
    return import.meta.env.VITE_API_URL;
  }
}
export default new EnvironmentService();
